import {i18nKey} from '@/locales/i18n';
import {RequestStatus} from './default';

export const C_MAP_URL = '/cmaps/';
export const STANDARD_FONT_DATA_URL = '/standard_fonts/';
export const MAX_WIDTH = 800;

export const TYPE_DOCUMENT = {
  PDF: 'application/pdf',
  IMAGE: 'image/',
};

export enum ContextMenuKey {
  ADD_NEW_ROW_ABOVE = 'ADD_NEW_ROW_ABOVE',
  ADD_NEW_ROW_BELOW = 'ADD_NEW_ROW_BELOW',
  DUPLICATE_ROW_ABOVE = 'DUPLICATE_ROW_ABOVE',
  DUPLICATE_ROW_BELOW = 'DUPLICATE_ROW_BELOW',
  DELETE_ROW = 'DELETE_ROW',
}

export enum TEMPLATE_TYPE {
  template = 'template',
  document_set = 'document_set',
}

export const MAXIMUM_VALUE_NUMBER = 5;

export enum PROCESSING_LIST_FILTER {
  SEARCH = 'search',
  STATUS = 'status',
  DATE_RANGE = 'dateRange',
}

/**
 * The "All" option needs a value no real status uses. The shared `DEFAULT_STATUS_ALL` (4)
 * collides with `RequestStatus.Cancelling`, which is why Cancelling could never be filtered.
 */
export const PROCESSING_STATUS_ALL = -1;

export const ITEM_STATUS_PROCESSING = [
  {value: PROCESSING_STATUS_ALL, label: () => i18nKey.processingScreen.status.all},
  {value: RequestStatus.Sending, label: () => i18nKey.processingScreen.status.sending},
  {value: RequestStatus.Processing, label: () => i18nKey.processingScreen.status.processing},
  {value: RequestStatus.Extracting, label: () => i18nKey.processingScreen.status.extracting},
  {value: RequestStatus.Success, label: () => i18nKey.processingScreen.status.finished},
  {value: RequestStatus.Error, label: () => i18nKey.processingScreen.status.failed},
  {value: RequestStatus.Cancelling, label: () => i18nKey.processingScreen.status.cancelling},
  {value: RequestStatus.Cancelled, label: () => i18nKey.processingScreen.status.cancelled},
];

export enum TEMPLATE_SYNC_STATUS {
  New = 'New',
  Updated = 'Updated',
  NotChanged = 'NotChanged',
}
